export default __webpack_public_path__ + "static/media/scansCircle.a82b225c.png";